// extracted by mini-css-extract-plugin
export var arkheSvgHome = "breadcrumb-module--arkhe-svg-home--b8d77";
export var breadcrumb = "breadcrumb-module--breadcrumb--79860";
export var breadcrumb__item = "breadcrumb-module--breadcrumb__item--02609";
export var breadcrumb__list = "breadcrumb-module--breadcrumb__list--4db86";
export var breadcrumb__text = "breadcrumb-module--breadcrumb__text--63729";
export var icon_home = "breadcrumb-module--icon_home--4ebb3";